import { FrameBusRegistry } from './types'

export const FRAME_BUS_PAGE_PROP = '__FRAME_BUS_PAGE__'

export const registry: FrameBusRegistry = {}
